import { render, staticRenderFns } from "./PCodeBox.vue?vue&type=template&id=d7152684&"
import script from "./PCodeBox.vue?vue&type=script&lang=js&"
export * from "./PCodeBox.vue?vue&type=script&lang=js&"
import style0 from "./PCodeBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports